// extracted by mini-css-extract-plugin
export default {"wrap":"Download_wrap__R5Ven","body":"Download_body__x38yJ","inps":"Download_inps__sRs1o"};